import * as React from 'react';
import * as moment from 'moment';
import InputMask from '../InputMask';
import Tooltip from '../Tooltip';
import { validators } from '../../../utils/ehrValidators';
import { MaskPattern } from 'src/utils/constValues';

export interface Props {
    onChange: (value: string, field: string) => void;
    field: string;
    id: string;
    label: string;
    value: string;
    rules?: Object;
    onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    extendClass?: string;
    disabled?: boolean;
    triggerCheckError?: boolean;
    triggerClearError?: boolean;
}

export interface State {
    errors: Array<string>;
    display: boolean;
    datePickerMask: string;
}

class DatePicker extends React.Component<Props, State> {
    private inputMask: InputMask;
    constructor(props: Props) {
        super(props);
        this.state = {
            errors: new Array<string>(),
            display: false,
            datePickerMask: ''
        };
    }

    componentWillReceiveProps(nextProps: Props) {
        const { rules, triggerCheckError, triggerClearError } = this.props;
        if (triggerCheckError !== nextProps.triggerCheckError) {
            let result = new Array<string>();
            if (rules) {
                Object.keys(rules).forEach(rule => {
                    const error = validators(rule, rules[rule], nextProps.value);
                    if (error.length > 0) {
                        result.push(error);
                    }
                });
            }
            if (result.length !== 0) {
                this.setState({
                    errors: result,
                    display: result.length > 0
                });
            }
        }
        if (triggerClearError !== nextProps.triggerClearError) {
            this.setState({
                errors: new Array<string>(),
                display: false
            });
        }
    }

    selectDate = (e: DatepickerEventObject): void => {
       
        const value = moment(e.date).format('MM/DD/YYYY');
        this.props.onChange(value, this.props.field);
        const errors = this.checkError(value);
        this.setState({
            errors: errors,
            display: errors.length > 0
        });
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        //this.props.onChange(e.target.value === '__/__/____' ? '' : e.target.value, this.props.field);
        if (e.target.value && e.target.value!== '__/__/____') {
            this.setState({datePickerMask: MaskPattern.DATE_PICKER});
        }
        else {
            this.setState({datePickerMask: ''});
        }
        this.props.onChange(e.target.value, this.props.field);
    }

    handleBlur = (): void => {
        const errors = this.checkError(this.props.value);
        this.setState({
            errors: errors
        });

        // work arround (wait select date from datepicker finish 1st)
        window.setTimeout(
            (): void => {
                this.setState((prevState: State) => {
                    return { display: prevState.errors.length > 0 };
                });
            },
            150
        );
    }

    checkError = (value: string): Array<string> => {
        const { rules } = this.props;
        if (rules) {
            let result = new Array<string>();
            Object.keys(rules).forEach(rule => {
                const error = validators(rule, rules[rule], value);
                if (error.length > 0) {
                    result.push(error);
                }
            });
            return result;
        } else {
            return new Array<string>();
        }
    }

    handleFocus = (): void => {
        this.setState({
            errors: new Array<string>(),
            display: false
        });
    }

    showDate = (e: React.MouseEvent<HTMLElement>): void =>  {
        this.inputMask.iconShowDatePicker();
    }
    
    render(): JSX.Element {
        const { id, extendClass, value, label, disabled } = this.props;
        const { errors, display, datePickerMask } = this.state;

        return (
            <Tooltip
                wrapper="div"
                title={errors.length > 0 && display ? label + errors.join(',') : ''}
                className={(errors.length > 0 && display ? 'has-error' : '') + (extendClass ? ' ' + extendClass : '')}
                isValidation={true}
            >
                <div className="input-group">
                    <InputMask
                        ref={r => this.inputMask = r!}
                        className="form-control"
                        placeholder="mm/dd/yyyy"
                        mask={datePickerMask}
                        id={id}
                        value={value ? value : ''}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        onFocus={this.handleFocus}
                        {...this.props.onKeyPress ? { onKeyPress: this.props.onKeyPress } : {}}
                        selectDate={this.selectDate}
                        disabled={disabled}
                    />
                    <div className="input-group-append">
                        <div className="input-group-text">
                            <i style={{ cursor: 'pointer' }} id={this.props.id} onClick={this.showDate} className="fa fa-calendar" />
                        </div>
                    </div>
                </div>
            </Tooltip>
        );
    }
}

export default DatePicker;


// WEBPACK FOOTER //
// ./src/components/shared/DatePicker/DatePicker.tsx